import { render, staticRenderFns } from "./PendingFollowups.vue?vue&type=template&id=90d08f0a&scoped=true&"
import script from "./PendingFollowups.vue?vue&type=script&lang=js&"
export * from "./PendingFollowups.vue?vue&type=script&lang=js&"
import style0 from "./PendingFollowups.vue?vue&type=style&index=0&id=90d08f0a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90d08f0a",
  null
  
)

export default component.exports